export default "__VITE_ASSET__C35IKYyM__"